module.exports = __webpack_public_path__ + "static/media/delete.a45355ec.svg";